import { createSelector } from 'reselect';

var getDate = function getDate(state) {
  return state.updatedDate;
};

export var getUpdatedDateFetching = createSelector(getDate, function (updatedDate) {
  return updatedDate.isFetching;
});
export var getUpdatedDateLoaded = createSelector(getDate, function (updatedDate) {
  return updatedDate.isLoaded;
});
export var getUpdatedDate = createSelector(getDate, function (_ref) {
  var date = _ref.date;
  return date;
});